<template>
  <div>
    <!-- 创建订单 -->
    <el-dialog title="创建订单" :visible.sync="addApplyVisible" width="1050px" :close-on-click-modal="false" center>
      <el-steps :active="activeStep" finish-status="success" simple style="margin-top: -20px">
        <!-- <el-step :title="'下单类型('+orderTypeMap[orderForm.orderType]+')'"></el-step> -->
        <el-step title="选择下单人"></el-step>
        <el-step title="选择商品"></el-step>
      </el-steps>
      <div style="min-height:400px;">
        <!-- 第一步 -->
        <div style="padding:20px 20px;border:1px solid #ddd;text-align:center;" v-if="activeStep==1">
          <el-form :inline="true">

            <el-row>
              <el-col :span="12">
                <el-form-item label="城市" prop="cityId">
                  <el-select v-model="orderForm.cityId" clearable placeholder="请选择城市" @change="cityChange2">
                    <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityAddress"
                               :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="服务站" prop="stationId">
                  <el-select v-model="orderForm.stationId" clearable placeholder="请选择服务站" @change="stationChange2">
                    <el-option v-for="(item,index) in stationList2" :key="index" :label="item.stationName"
                               :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="服务者" prop="workerNo">
                  <el-select v-model="orderForm.workerNo" clearable placeholder="请选择服务者" filterable>
                    <el-option v-for="(item,index) in workerList" :key="index" :label="item.workerName+'('+item.workerNo+')'"
                               :value="item.workerNo"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="下单类型">
                  <el-select v-model="orderForm.orderType" clearable placeholder="请选择" filterable>
                    <el-option v-for="(item,index) in orderTypeMap" :key="index" :label="item"
                               :value="index"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <div style="padding:20px 20px;border:1px solid #ddd;" v-if="activeStep==2">
          <!-- 商品搜索条件 -->
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="商品名称">
              <el-input v-model="productQuery.commodityName" placeholder="请输入商品名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="商品编码">
              <el-input v-model="productQuery.spuCode" placeholder="请输入商品编码" clearable></el-input>
            </el-form-item>
            <el-form-item label="商品类目" v-if="productQuery.type==2">
              <el-cascader v-model="productQuery.categoryId" :options="categoryList" :props="{ expandTrigger: 'hover',value:'id',label: 'categoryName',
          children: 'childCategorys'}" clearable :show-all-levels="false" size="mini"></el-cascader>
            </el-form-item>
            <el-form-item label="商品类型">
              <el-select v-model="productQuery.type" placeholder="请选择商品类型" clearable>
                <el-option label="套餐" v-if="orderForm.orderType!=2" :value="1"></el-option>
                <el-option label="单品" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="售卖类型">
              <el-select v-model="productQuery.salesType" multiple placeholder="请选择商品类型" clearable>
                <el-option v-if="orderForm.orderType==2" label="租借" :value="1+''"></el-option>
                <el-option v-if="orderForm.orderType==1" label="售卖" :value="2+''"></el-option>
                <el-option v-if="orderForm.orderType==2||orderForm.orderType==1" label="租借和售卖"
                           :value="3+''"></el-option>
                <el-option v-if="orderForm.orderType==3" label="补贴(领取)" :value="4+''"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="productSearch">搜索</el-button>
            </el-form-item>
          </el-form>

          <!-- 商品列表 -->
          <el-table :data="addProductQueryShow" border class="table" max-height="320" ref="multipleTable">
            <el-table-column prop="commodityName" label="商品名称" width="100" fixed="left"></el-table-column>
            <el-table-column prop="spuCode" label="商品编码"></el-table-column>
            <el-table-column prop="categoryName" label="商品类目"></el-table-column>
            <el-table-column prop="brandName" label="品牌"></el-table-column>
            <el-table-column prop="salesType" label="销售类型">
              <template slot-scope="scope">
                <span>{{ salesTypeMap[scope.row.salesType] }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="satus" label="商品状态">
              <template slot-scope="scope">{{ scope.row.status | statusFilter }}</template>
            </el-table-column>
            <el-table-column prop="detail.detailDesc" label="商品详情描述"></el-table-column>

            <el-table-column prop="name" label="操作" width="55">
              <template slot-scope="scope">
                <el-button @click="addConfirm(scope.row)" type="text" size="small">添加</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 已选商品 -->
          <div style="padding:0 10px 10px;border:1px solid #ddd;margin-top:20px;">
            <!-- 已选单品 -->
            <p style="margin:20px 0; border-left:4px solid #409EFF;">已选商品：</p>
            <el-table :data="skuSelectForm.chooseList" border class="table" max-height="320" ref="multipleTable">
              <el-table-column prop="package" label="商品类型" width="100" fixed="left">
                <template slot-scope="scope">
                  <span v-if="scope.row.myCurr.type==1"
                        style="color:red;">套餐-{{ scope.row.myCurr.commodityName }}</span>
                  <span v-if="scope.row.myCurr.type==2" style="color:blue;">单品</span>
                </template>
              </el-table-column>
              <el-table-column prop="commodityName" label="商品和规格">
                <template slot-scope="scope">
                  <template v-for="item in scope.row.mydata">
                                        <span :key="item.id">
                                            {{ item.commodityName }} ({{ item.propertyValue }})
                                            <span
                                              v-if="scope.row.myCurr.type==1">(数量*{{ getBomListNumber(scope.row.myCurr.bomList, item.spuInfo.id) }})</span>
                                            <br/></span>
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="propertyValue" label="售卖单价" width="100">
                <template slot-scope="scope">
                  {{ priceCount(scope.row.mydata, scope.row.myCurr, 1) }}
                </template>
              </el-table-column>
              <el-table-column prop="propertyValue" label="租赁单价" width="100">
                <template slot-scope="scope">
                  {{ priceCount(scope.row.mydata, scope.row.myCurr, 2) }}
                </template>
              </el-table-column>
              <el-table-column prop="propertyValue" label="租赁押金" width="100">
                <template slot-scope="scope">
                  {{ priceCount(scope.row.mydata, scope.row.myCurr, 3) }}
                </template>
              </el-table-column>
              <el-table-column label="份数" v-if="orderForm.orderType!=2" width="250">
                <template slot-scope="scope">
                  <el-input type="number" v-model.trim="scope.row.applyNumber"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="租赁商品SN码" v-if="orderForm.orderType==2 " width="250">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.chooseSn" filterable placeholder="请选择SN码" style="width:100%">
                    <template v-for="item in scope.row.mydata[0].allAvailableList">
                      <!--租赁只有单品只有一个mydata -->
                      <el-option :key="item" :label="item" :value="item"></el-option>
                    </template>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="" label="操作" width="60">
                <template slot-scope="scope">
                  <el-button @click="delRow(scope.$index)" type="text" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

            <p style="margin:20px 0; border-left:4px solid #409EFF;">订单信息：</p>
            <el-form style="margin-top:10px;">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="城市" prop="cityId">
                    <el-select v-model="orderForm.cityId" placeholder="请选择城市" disabled>
                      <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityAddress"
                                 :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="服务站" prop="stationId">
                    <el-select v-model="orderForm.stationId" placeholder="请选择服务站" @change="stationChange2">
                      <el-option v-for="(item,index) in stationList2" :key="index" :label="item.stationName"
                                 :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="服务者" prop="workerNo">
                    <el-select v-model="orderForm.workerNo" placeholder="请选择服务者" filterable>
                      <el-option v-for="(item,index) in workerList" :key="index" :label="item.workerName"
                                 :value="item.workerNo"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="下单类型">
                    <el-select v-model="orderForm.orderType" placeholder="请选择" disabled>
                      <el-option v-for="(item,index) in orderTypeMap" :key="index" :label="item"
                                 :value="index"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="收货方式">
                    <el-select v-model="orderForm.outMode" placeholder="请选择" filterable>
                      <el-option v-for="(item,index) in outModeMap" :key="index" :label="item"
                                 :value="index+''"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

            <template v-if="orderForm.orderType==2">
              <p style="margin:20px 0; border-left:4px solid #409EFF;">租赁信息：</p>
              <el-form style="margin-top:10px;" :inline="true">
                <el-row>

                  <!-- <el-form-item label="押金">
                      <el-input type="number" v-model="orderForm.placeOrderLeaseDto.deposit" placeholder="押金" clearable></el-input>
                  </el-form-item> -->

                  <el-form-item label="租期">
                    <el-date-picker :picker-options="pickerOptions1" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                    v-model="orderForm.placeOrderLeaseDto.rentTime" type="daterange" range-separator="至"
                                    start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                  </el-form-item>

                </el-row>
                <el-row>

                  <el-form-item label="租赁人地址">
                    <el-input v-model="orderForm.placeOrderLeaseDto.rentAccountAddr" placeholder="租赁人地址"
                              clearable></el-input>
                  </el-form-item>

                  <el-form-item label="备注">
                    <el-input v-model="orderForm.placeOrderLeaseDto.remark" placeholder="备注" clearable></el-input>
                  </el-form-item>

                </el-row>
              </el-form>
            </template>

          </div>

        </div>

      </div>

      <span slot="footer" class="dialog-footer" v-if="activeStep==1">
                <el-button type="primary" @click="addApplyVisible=false">取消</el-button>
                <el-button type="primary" @click="nextStep">下一步</el-button>
            </span>
      <span slot="footer" class="dialog-footer" v-if="activeStep==2">
                <el-button type="primary" @click="addApplyVisible=false">取消</el-button>
                <el-button type="primary" @click="confSubmit">提交</el-button>
            </span>
    </el-dialog>

    <!-- 规格选择 -->
    <el-dialog title="商品规格" :visible.sync="skuSelectVisable" width="700px" :close-on-click-modal="false" center>

      <p style="margin:0 20px 20px;">请选择商品规格</p>
      <el-form ref="skuSelectForm" label-width="140px" :model="skuSelectForm" size="medium"
               v-for="(spu, index) in skuSelectForm.spuList" :key="index">
        <el-row>
          <el-col :span="5" :offset="2" style="padding-top:6px;">
            {{ spu.spuInfo.commodityName }}
            <span v-if="spu.curr.type==1">(数量*{{ getBomListNumber(spu.curr.bomList, spu.spuInfo.id) }})</span>
          </el-col>

          <el-col :span="6">
          </el-col>

          <el-form-item :label="'选择商品规格'" :prop="'skuId'" :rules="{
      required: true, message: '规格不能为空', trigger: 'blur'
    }">
            <el-select v-model="spu.skuId" placeholder="请选择规格" clearable size="mini">
              <el-option v-for="item in ( spu.skuList)" :key="item.id" :label="item.propertyValue"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <el-form v-if="orderForm.orderType!=2">
        <el-col :span="5" :offset="2">
          &nbsp;
        </el-col>
        <el-form-item :label="'请填写下单份数'">
          <el-input size="mini" style="width:150px;" type="number" v-model="skuSelectForm.tempNumber"
                    placeholder="填写下单份数" clearable></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
                <el-button @click="skuSelectVisable=false">取消</el-button>
                <el-button @click="confSku" type="primary">确定</el-button>
            </span>

    </el-dialog>

  </div>
</template>
<script>
import moment from "moment";
import Pagination from "../../common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import Service from "@/script/api/service";
import globalData from "@/components/common/globaldata/global.data.vue";
import "../css/index.css";

let vm;
export default {
  filters: {
    statusFilter(value) {
      const rs = vm.statusList.filter((item) => {
        return item.id === value;
      });

      if (rs != null && rs.length > 0) {
        return rs[0].text;
      }
    },
  },
  data() {
    return {
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      workerList: [],
      cityList: [],
      stationList2: [],
      addApplyVisible: false, //主弹窗显示
      skuSelectVisable: false, //spu下的sku选择
      activeStep: 1,
      categoryList: [], //类目list
      addProductQueryShow: [], //查询spu商品
      productQuery: {
        cityId: null,
        commodityName: "",
        spuCode: "",
        categoryId: "",
        type: 2,
        salesType: [],
      },
      skuSelectForm: {
        tempNumber: null,
        houseId: "",
        chooseList: [], //是选择的sku
        spuList: [
          {
            skuId: "",
            curr: {},
            spuInfo: {},
            skuList: [],
          },
        ],
      },
      statusList: [
        {
          id: 1,
          text: "待审核",
        },
        {
          id: 2,
          text: "待上架",
        },
        {
          id: 3,
          text: "审核不通过",
        },
        {
          id: 4,
          text: "上架中",
        },
        {
          id: 5,
          text: "已下架",
        },
      ],
      salesTypeMap: {
        1: "租借",
        2: "售卖",
        3: "租借和售卖",
        4: "补贴",
      },
      orderTypeMap: {
        1: "购买",
        2: "租赁",
        3: "领用",
      },
      outModeMap: {
        1: "邮寄",
        2: "货拉拉",
        3: "现场领取",
      },
      orderForm: {
        cityId: null,
        stationId: null,
        snList: [], //租赁的东西放这里
        goodsList: [
          // {
          //     buyNumber: null,
          //     skuId: null,
          //     skuName: "",
          //     snCode: "",
          // },
        ],
        packageBuyList: [
          // {
          //     spuCode:null,
          //     skuId:null,
          //     buyNum:null,
          // }
        ],
        orderType: null,
        outMode: "3", //收货方式
        placeOrderLeaseDto: {
          deposit: null,
          remark: "",
          rentAccountAddr: "",
          // rentAccountId: null,
          // rentAccountName: "",
          // rentAccountPhone: "",
          rentTime: [],
          rentEndTime: "",
          rentStartTime: "",
        },
        orderSnapshot: {
          detail: [
            // {
            //     attribute: "",
            //     buyNumber: 0,
            //     commodityName: "",
            //     commodityType: "",
            //     spuCode: "",
            // },
          ],
          // orderAmount: "",
          // orderNo: "",
          orderType: "",
        },
        workerNo: null,
        createUserId: null,
        createUserName: null,
        // receiverName: null,
        // receiverPhone: "",
      },
    };
  },
  beforeCreate() {
    vm = this;
  },
  methods: {
    addOrder() {
      this.addApplyVisible = true;
      this.activeStep = 1;
      this.skuSelectForm.chooseList = [];
      let citys = window.localStorage.getItem("allCityList");
      if (!citys) {
        Service
          .$axiosGetAllCityStation({
            // userId:  JSON.parse(window.localStorage.getItem("userInfo")).id
          })
          .then(res => {
            if (res.data.errno == "0") {
              citys=res.data.data;
              window.localStorage.setItem("allCityList",JSON.stringify(citys) );
            } else {
              this.$message.warning(res.data.errmsg);
            }

          })
      }
      this.cityList = JSON.parse(
        citys
      );
      this.orderForm = {
        cityId: null,
        stationId: null,
        snList: [], //租赁的东西放这里
        goodsList: [
          // {
          //     buyNumber: null,
          //     skuId: null,
          //     skuName: "",
          //     snCode: "",
          // },
        ],
        packageBuyList: [
          // {
          //     spuCode:null,
          //     skuId:null,
          //     buyNum:null,
          // }
        ],
        orderType: null,
        outMode: "3", //收货方式
        placeOrderLeaseDto: {
          deposit: null,
          remark: "",
          rentAccountAddr: "",
          // rentAccountId: null,
          // rentAccountName: "",
          // rentAccountPhone: "",
          rentTime: [],
          rentEndTime: "",
          rentStartTime: "",
        },
        orderSnapshot: {
          detail: [
            // {
            //     attribute: "",
            //     buyNumber: 0,
            //     commodityName: "",
            //     commodityType: "",
            //     spuCode: "",
            // },
          ],
          // orderAmount: "",
          // orderNo: "",
          orderType: "",
        },
        workerNo: null,
        createUserId: null,
        createUserName: null,
        // receiverName: null,
        // receiverPhone: "",
      };
    },
    nextStep() {
      if (this.orderForm.cityId == null || this.orderForm.cityId == "") {
        this.$message.error("请选择城市");
        return;
      }
      if (
        this.orderForm.stationId == null ||
        this.orderForm.stationId == ""
      ) {
        this.$message.error("请选择服务站");
        return;
      }
      if (
        this.orderForm.workerNo == null ||
        this.orderForm.workerNo == ""
      ) {
        this.$message.error("请选择服务者");
        return;
      }
      if (
        this.orderForm.orderType == null ||
        this.orderForm.orderType == ""
      ) {
        this.$message.error("请选择下单类型");
        return;
      }
      this.activeStep = 2;

      this.setproductQueryData(); //设置类型值

      this.getCateGoryTree(); //类目
      this.productSearch(); //查询商品列表
    },
    confSubmit() {
      console.log("订单开始提交");
      let reqData = [];
      if (!this.checkRentForm()) {
        return;
      }
      let boo = this.setFormData(); //填充表单信息
      if (!boo) {
        return;
      }

      console.log("下单信息", this.orderForm);

      //提交订单
      wmsApi
        .$axioswmsOrderplaceOrder(this.orderForm)
        .then((res) => {
          if (res.data.errno == 0) {
            this.$message.success("提交成功");
            this.addApplyVisible = false;
            // this.$emit('querySearch');
            this.$parent.querySearch();
          } else {
            this.$message.error(res.data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setFormData() {
      let orderSnapshot = {
        //  订单商品json信息
        detail: [],
        orderType: this.orderTypeMap[this.orderForm.orderType],
      };
      let tempCode = [];
      let tempGoodsList = [];
      let tempPackageBuyList = [];

      console.log("选择的商品详情：", this.skuSelectForm);

      this.skuSelectForm.chooseList.forEach((e) => {
        let tempAtt = ""; //套餐下的商品
        //订单关键信息
        tempCode.push(e.chooseSn);
        e.mydata.forEach((da) => {
          let nums = 1; //套餐下商品组合的数量
          if (e.myCurr.type == 1) {//e.myCurr.type 1套餐，2单品
            nums = this.getBomListNumber(
              e.myCurr.bomList,
              da.spuInfo.id
            );
          }

          if (e.myCurr.type == 2) {//2单品放入goodslist里
            tempGoodsList.push({
              skuId: da.skuId,
              buyNumber: e.applyNumber * nums,
              // skuName: da.commodityName + " (" + da.propertyValue + ")",
            });
          }

          if (e.myCurr.type == 1) {//1套餐单独计算
            tempPackageBuyList.push({
              spuCode: e.myCurr.spuCode,
              skuId: da.skuId,
              buyNum: e.applyNumber,
              skuBuyNum: nums
            });
          }

          tempAtt =
            tempAtt +
            da.commodityName +
            "(" +
            da.propertyValue +
            ")" +
            "(" +
            nums +
            ")" +
            "<br/>";
        });


        //订单商品json信息
        orderSnapshot.detail.push({
          attribute: tempAtt,
          buyNumber: e.applyNumber,
          commodityName: e.myCurr.commodityName,
          commodityType: e.myCurr.type == 1 ? "套餐" : "单品",
          spuCode: e.myCurr.spuCode,
        });
      });

      if (this.orderForm.orderType == 2) {
        //租赁存到sncode里
        if (this.isRepeat(tempCode)) {
          this.$message.error("所选商品SN码有重复，请修改后再提交");
          return false;
        }
        this.orderForm.snList = tempCode;

        this.orderForm.placeOrderLeaseDto.rentStartTime =
          this.orderForm.placeOrderLeaseDto.rentTime[0];
        this.orderForm.placeOrderLeaseDto.rentEndTime =
          this.orderForm.placeOrderLeaseDto.rentTime[1];
        // return false;
      }

      this.orderForm.goodsList = tempGoodsList;
      this.orderForm.createUserId = globalData.userInfo.id;
      this.orderForm.createUserName = globalData.userInfo.userName;
      this.orderForm.orderSnapshot = orderSnapshot;

      this.orderForm.packageBuyList = tempPackageBuyList;


      return true;
    },
    checkRentForm() {
      if (this.skuSelectForm.chooseList.length == 0) {
        this.$message.error("请添加商品");
        return;
      }

      if (this.orderForm.orderType != 2) {
        //1 购买  3领用(补贴)  2租赁
        for (let i = 0; i < this.skuSelectForm.chooseList.length; i++) {
          if (
            !this.skuSelectForm.chooseList[i].applyNumber ||
            this.skuSelectForm.chooseList[i].applyNumber <= 0
          ) {
            this.$message.error("商品数量不能小于0");
            return;
          }
        }
      }
      if (this.orderForm.orderType == 2) {
        //租赁
        for (let i = 0; i < this.skuSelectForm.chooseList.length; i++) {
          if (
            this.skuSelectForm.chooseList[i].chooseSn == null ||
            this.skuSelectForm.chooseList[i].chooseSn == ""
          ) {
            this.$message.error("租赁商品，请选择商品sn码");
            return;
          }
        }
        // if (
        //     this.orderForm.placeOrderLeaseDto.deposit == null ||
        //     this.orderForm.placeOrderLeaseDto.deposit == ""
        // ) {
        //     this.$message.error("请输入押金");
        //     return false;
        // }

        if (this.orderForm.placeOrderLeaseDto.rentTime.length == 0) {
          this.$message.error("请选择租期");
          return false;
        }
        if (
          this.orderForm.placeOrderLeaseDto.rentAccountAddr == null ||
          this.orderForm.placeOrderLeaseDto.rentAccountAddr == ""
        ) {
          this.$message.error("请填写租赁人地址");
          return false;
        }
      }
      return true;
    },
    setproductQueryData() {
      //查询条件 设置
      this.productQuery = {
        commodityName: "",
        spuCode: "",
        brandName: "",
        categoryId: "",
        type: 2,
        salesType: null,
        cityId: null,
      };
      console.log(this.orderForm.orderType);
      //1 购买 2租赁 3领用(补贴)
      if (this.orderForm.orderType == 1) {
        this.productQuery.salesType = ["2", "3"];
      }
      if (this.orderForm.orderType == 2) {
        this.productQuery.salesType = ["1", "3"];
        this.productQuery.type = 2; //单品
      }
      if (this.orderForm.orderType == 3) {
        this.productQuery.salesType = ["4"];
      }
      /**
       *  <el-select v-model="productQuery.salesType" placeholder="请选择商品类型" clearable>
       <el-option v-if="orderForm.orderType==2" label="租借" :value="1"></el-option>
       <el-option v-if="orderForm.orderType==1" label="售卖" :value="2"></el-option>
       <el-option v-if="orderForm.orderType==2||orderForm.orderType==1" label="租借和售卖" :value="3"></el-option>
       <el-option v-if="orderForm.orderType==3" label="补贴(领取)" :value="4"></el-option>
       </el-select>
       */
    },
    async getAvailableSN(skuId, stationId) {
      let s = await wmsApi.$axiosGetAvaiableSnCode({
        skuId: skuId,
        stationId: stationId
      });
      return s.data.data;
    },
    getCateGoryTree() {
      wmsApi
        .$axiosCategoryTree({})
        .then((res) => {
          this.categoryList = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    productSearch() {
      if (
        this.productQuery.salesType == null ||
        this.productQuery.salesType.length == 0
      ) {
        this.$message.error("请选择售卖类型");
        return;
      }
      if (
        this.productQuery.type == null ||
        this.productQuery.type == ""
      ) {
        this.$message.error("请选择商品类型");
        return;
      }
      let temp = {
        page: 1,
        size: 1000,
        cityId:
          this.productQuery.type == "1"
            ? this.orderForm.cityId
            : null, //this.productQuery.cityId 套餐带城市
        type: this.productQuery.type,
        status: 4,
        commodityName: this.productQuery.commodityName,
        spuCode: this.productQuery.spuCode,
        salesType: this.productQuery.salesType.join(","),
      };
      if (this.productQuery.type == 2) {
        temp.categoryId =
          this.productQuery.categoryId.length >= 3
            ? this.productQuery.categoryId[2]
            : "";
      }
      wmsApi
        .$axiosCommodityList(temp)
        .then((res) => {
          this.addProductQueryShow = res.data.data.list;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addConfirm(row) {
      console.log(row);
      this.skuSelectVisable = true;

      if (row.type == 1) {
        //套餐
        this.skuSelectForm.spuList = [];
        let that = this;
        row.childCommoditys.childDetail.forEach((e) => {
          let dataArr = {
            skuId: e.childSpuDetail.length > 0 ? e.childSpuDetail[0].id : "",
            curr: row,
            spuInfo: e.spuInfo,
            skuList: e.childSpuDetail,
          };
          that.skuSelectForm.spuList.push(dataArr);
        });

        console.log(that.skuSelectForm.spuList);
      } else {
        //单品
        this.skuSelectForm.spuList = [];
        let dataArr = {
          skuId: row.childCommoditys.childDetail.length > 0 ? row.childCommoditys.childDetail[0].id : "",
          curr: row,
          spuInfo: row,
          skuList: row.childCommoditys.childDetail,
        };
        this.skuSelectForm.tempNumber = null;
        this.skuSelectForm.spuList.push(dataArr);
      }
    },
    async confSku() {
      console.log("选择了", this.skuSelectForm);
      // this.tempArrayList

      if (
        this.orderForm.orderType != 2 &&
        this.skuSelectForm.tempNumber <= 0
      ) {
        this.$message.error("请输入份数");
        return;
      }

      let temparr = [];
      let myCurr = {};
      for (const e of this.skuSelectForm.spuList) {
        for (const tsk of e.skuList) {
          var sk = JSON.parse(JSON.stringify(tsk));
          if (e.skuId == sk.id) {
            // sk.package = e.curr.type; //标识1套餐，2单品
            // sk.spu = e.curr;
            myCurr = e.curr;
            sk.skuId = sk.id; //要提交的
            sk.spuInfo = e.spuInfo;
            // sk.applyNumber=0;//要提交的
            // sk.chooseSn='';//租赁的
            if (this.orderForm.orderType == 2 ) {
              sk.allAvailableList = await this.getAvailableSN(sk.skuId, this.orderForm.stationId);
            }
            temparr.push(sk);
          }
        }
      }
      if (
        temparr.length == 0 ||
        temparr.length != this.skuSelectForm.spuList.length
      ) {
        this.$message.error("请选择商品规格");
        return;
      }
      // this.skuSelectForm.chooseList =
      //     this.skuSelectForm.chooseList.concat(temparr);
      let d = {
        mydata: temparr,
        myCurr: myCurr,
        applyNumber: this.skuSelectForm.tempNumber,
        chooseSn: null,
      };
      this.skuSelectForm.chooseList.push(d);
      console.log("总共选择了", this.skuSelectForm);
      this.skuSelectVisable = false;
    },
    getBomListNumber(bomList, spuId) {
      console.log("套餐规格数量来了。。");
      if (bomList == null || bomList == undefined) {
        return 0;
      }
      let num = 0;
      bomList.forEach((e) => {
        if ((e.spuId == spuId)) {
          num = e.num;
        }
      });
      return num;
    },
    delRow(index) {
      this.skuSelectForm.chooseList.splice(index, 1);
    },
    cityChange2(value) {
      this.orderForm.stationId = "";
      let currentStation = this.cityList.filter((item) => {
        return item.id == value;
      });

      if (currentStation.length > 0) {
        this.stationList2 = currentStation[0].stationList;
      } else {
        this.stationList2 = [];
        return;
      }
      this.orderForm.workerNo = "";
      Service.$axiosGetWorkerList({
        cityId: this.orderForm.cityId,
      })
        .then((res) => {
          this.workerList = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    stationChange2(value) {
      this.orderForm.workerNo = "";
      if (value != null) {
        Service.$axiosGetWorkerList({
          cityId: this.orderForm.cityId,
          stationId: this.orderForm.stationId,
        })
          .then((res) => {
            this.workerList = res.data.data;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    isRepeat(arr) {
      //重复校验
      var hash = {};
      for (var i in arr) {
        if (hash[arr[i]]) return true;
        hash[arr[i]] = true;
      }
      return false;
    },
    getUuid() {
      //唯一值
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";

      var uuid = s.join("");
      return uuid;
    },
    priceCount(myDataSkuList, spuMyCurr, type) {
      //myDataSkuList所选的sku,spuMyCurr是SPU
      //type 1售卖，2租赁，3押金
      console.log(myDataSkuList);

      if(spuMyCurr.type==1){
        //套餐单价，套餐直接用套餐售卖价
        return spuMyCurr.childCommoditys.salePrice;
      }

      let price = 0;
      myDataSkuList.forEach((e) => {
        let num = 1; //组成数量 单品是1个
        if (spuMyCurr.type == 1) {
          //套餐
          num = this.getBomListNumber(
            spuMyCurr.bomList,
            e.spuInfo.id
          );
        }
        if (type == 1 && e.salePrice != null) {
          price = price + num * e.salePrice;
        }
        if (type == 2 && e.salePrice != null) {
          price = price + num * e.rentPrice;
        }
        if (type == 3 && e.salePrice != null) {
          price = price + num * e.deposit;
        }
      });
      return price;
    },
  },
};
</script>
<style>
</style>
